import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';

@jsonObject
export class AdminBoxQuestionnaireChangeSelectionRequest {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly selectedOptionId!: Guid;

  public constructor(
    private readonly data: {
      id: Guid;
      selectedOptionId: Guid;
    },
  ) {
    this.id = this.data.id;
    this.selectedOptionId = this.data.selectedOptionId;
  }
}
